import { Tag as TagAntd } from 'antd';
import styled from 'styled-components';

import colors from '../../../../styles/colors';

export const BodyContainer = styled.div``;

export const Lote = styled.div`
  margin-bottom: 16px;
  padding: 16px 24px;

  background: ${colors.$light};
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.12);
  border-radius: 8px;

  > button {
    padding: 0;
  }

  > button u {
    font-weight: 700;
    text-decoration: none;
  }
`;

export const HeaderLote = styled.div`
  margin-bottom: 16px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  b {
    margin-right: 16px;
    font-weight: 700;
  }
`;

export const InfoContainer = styled.div``;

export const ActionContainer = styled.div`
  padding: 0px 15px;
`;

export const DetalhesLote = styled.div`
  margin-bottom: 10px;

  display: grid;
  grid-template-columns: 17% 12% 10% 15% 10% 12% 15% 6%;
`;

export const CampoLote = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    color: ${colors.$greyscale_light_grey_9};
  }

  p {
    margin-top: 5px;
  }
`;

export const CampoLoteLabel = styled.span`
  color: ${colors.$greyscale_light_grey_9};
`;

export const CampoLoteValor = styled.div`
  max-width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
`;

export const StatusLote = styled.div`
  display: flex;
  align-items: center;
`;

export const Tag = styled(TagAntd)`
  color: ${props => props.texto} !important;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  border-radius: 8px;
  margin: 10px 0;
  padding: 1px 10px;
  border: none;
`;
